/**
 * The Button component will be able to receive a type property.
 * This type will allow the Button to use a different className depending on the brand.
 * This will avoid having this mapping into the CSS, which causes lot of undesired duplication
 * Bigger CSS files due to the use of extend or having to create mapping css classes.
 *
 * The exported function will receive a type and will return the class to use depending on the brand
 * Without this, all brands would use the same className, having to create new CSS classes
 */

import { v as bvVar } from 'bv';

const mappings = {
  'site-header-account-deposit': {
    default: 'is-secondary',
    12: 'is-default',
  },
  'regpath-login-now-button': {
    default: 'link-style',
    12: 'is-primary',
  },
  'account-form-decision-box-yes': {
    default: 'bvs-button-alternative is-info',
    12: 'is-primary',
  },
  'account-form-decision-box-no': {
    default: 'is-info',
    12: 'is-primary',
  },
  'cookies-policy-button': {
    default: 'is-secondary is-info',
    12: 'is-primary',
  },
  'inplay-slider-button': {
    default: 'inplay-sports-slider_element',
    12: 'bvs-button-tab inverted',
  },
  'inplay-slider-button-upcoming': {
    default: 'inplay-sports-slider_element',
    12: 'bvs-button-tab',
  },
  'account-overview-personal-details-edit': {
    default: 'bvs-button-alternative is-secondary ',
    12: 'bvs-button is-primary',
  },
  'deposit-limit-btn-submit': {
    default: 'is-secondary is-round',
    12: 'is-primary',
  },
  'deposit-limit-option-btn': {
    default: 'is-secondary is-round',
    12: 'is-primary',
  },
  'password-change-button': {
    default: 'full-width',
    12: ' ',
  },
  'raf-copy': {
    default: 'is-secondary',
    12: 'is-primary',
  },
  'login-view-password-change-button': {
    default: 'bvs-button-alternative is-secondary',
    12: 'login-password-change-link',
  },
  'login-view-register-button': {
    default: 'bvs-button is-primary is-round',
    12: 'bvs-button-alternative is-primary',
  },
  'password-reset-button': {
    default: 'is-secondary full-width',
    12: 'is-primary',
  },
  'segregation-selector-button': {
    default: 'bvs-button-alternative is-secondary is-round',
    12: 'bvs-button-card-alternative',
  },
  'market-view-see-more-button': {
    default: 'is-success',
    12: 'is-primary',
  },
  'market-view-show-more-button': {
    default: 'is-secondary',
    12: 'is-primary',
  },
  'account-verification-button': {
    default: 'bvs-button-alternative is-secondary',
    12: 'bvs-button is-primary',
  },
  'settings-view-button': {
    default: 'bvs-button-alternative is-secondary',
    12: 'bvs-button is-primary',
  },
};

export default (type) => mappings[type] && (
  mappings[type][bvVar('brandId')] || mappings[type].default
);
